import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { useIntl, connect } from 'umi';
import { Col, Card, Row, Button } from 'tea-component';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import SvgIcon from '@/pages/home/components/SvgIcon';
import SensorTower from '@/pages/intelligence/assets/svg/dataSource/sensor-tower.svg';
import { getFormattedCardData } from './cardUtils';
// import { newMathFormat } from '@/pages/intelligence/utils/commonUtils';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';
import Loading from '@/pages/intelligence/components/Loading';
import UserGuideCompetitor, {
  COMPETITOR_GUIDE_CLASSNAMES,
} from '@intelligence/components/UserGuide/Competitor';
import { PC_CONSOLE_COMBINE_ENTITY_TYPE } from '@intelligence/pages/TopCharts/_config/topChartsConst';
import SummaryCard from '@/pages/intelligence/components/SummaryCard';
import SourceExplanation from '@/pages/intelligence/components/SummaryCard/components/SourceExplanation';
import useSummarySourceState from '@/pages/intelligence/components/SummaryCard/useSummarySourceState';
// import CardContext from '@/pages/intelligence/pages/TopCharts/components/DetailsPage/CardContext';
import OverviewCard from '@intelligence/components/OverviewCard';

import './index.scss';

function PerformanceSummary(props: any) {
  const {
    detailIndex = [],
    conditionPlatform,
    // isCalibrated,
    conditionDate,
    setActiveId,
    setActiveSegment,
    // activeId,
    moduleName,
    gameId,
    conditionMarket,
    entityType,
    rankLoading,
    cardloading,
    isOperateRegion,
  } = props;

  const { formatMessage } = useIntl(); // 中英切换方法
  const [cardData, setCardData] = useState<any>([]);
  const [cardDataMore, setCardDataMore] = useState<any>([]);
  const [isPolishing, setIsPolishing] = useState(false);
  const [state, setState] = useState(false);

  const { openSource, handleClickSourceTips } = useSummarySourceState();

  // 判断卡片中是否存在补齐数据
  const getIsPolishing = () => {
    const _arr = JSON.parse(JSON.stringify(detailIndex));
    const _history = _arr?.map((item: any, index: number) => item?.History).flat(2);
    const _isPolishing = _history?.some((item: any) => item?.b_predict == true);
    setIsPolishing(_isPolishing);
  };

  // const dealSepcialValue = (value: any) => {
  //   if (value === null) {
  //     return null;
  //   }
  //   if (value === 0 || value === '0') {
  //     return 0;
  //   }
  //   return newMathFormat(value);
  // };

  useEffect(() => {
    setCardData([]);
    setCardDataMore([]);
    const cardDataList =
      getFormattedCardData(detailIndex, entityType, conditionDate, conditionPlatform) || [];
    // let cardDataList = getFormattedData(detailIndex ? detailIndex : []) || [];
    setCardData(cardDataList?.slice(0, 6));
    if (cardDataList?.length > 6) {
      setCardDataMore(cardDataList?.slice(6, cardDataList?.length));
    }
    // setCardData(getNewAverageArray(getFormattedData(detailIndex ? detailIndex : []), 3));
    getIsPolishing();
  }, [detailIndex, conditionDate, conditionPlatform]);

  const isAdustTooltipPosition = !(entityType === 'mobile' && moduleName === 'mobileGames');

  return (
    <Card className="dbi-performance-summary">
      <Card.Body
        title={
          <div className="performance-felx">
            <span className="performance-felx-text">
              {formatMessage({ id: 'dbi_performance_summary' })}
            </span>
            {entityType === 'mobile' && (
              <TipContext
                className="icon-top"
                tipText={formatMessage(
                  { id: 'dbi_performance_summary_tip' },
                  {
                    sensorTower: (
                      <img
                        className="overview-sensortower-tip-img"
                        src={SensorTower}
                      />
                    ),
                  },
                )}
              />
            )}

            {entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE && (
              <>
                <span className="dib-sourcetips-explanation-divide"></span>
                <SourceExplanation
                  handleClickSourceState={handleClickSourceTips}
                  openSource={openSource}
                />
              </>
            )}
          </div>
        }
      >
        {cardloading ? (
          <>
            <div
              style={{
                height: 200,
                color: '#444',
              }}
            >
              <Loading content={formatMessage({ id: 'common_loading' })} />
            </div>
          </>
        ) : (
          <>
            {entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE && openSource && (
              <SummaryCard isSourceTips={true} openSource={openSource} />
            )}
            <Row>
              {cardData?.map((item: any, index: number) => {
                return item.titleIcon === 'viewers' ? null : (
                  <Col span={8}>
                    <OverviewCard
                      // <CardContext
                      key={`indicator${item.titleContent}`}
                      className={classnames({
                        // PC的digitalRevenue指标的卡片 在Competitor新手引导中 有引用，所以加了这个特殊的className（无任何样式，仅供匹配dom元素）
                        [COMPETITOR_GUIDE_CLASSNAMES.ELEMENT4]:
                          item?.metricUserGuide === 'digitalRevenue',
                      })}
                      titleContent={item.titleContent}
                      isShowDataSourceIcon
                      titleIcon={item.titleIcon}
                      // data_source={item.data_source}
                      data_source={entityType === 'mobile' ? item?.data_source : item?.titleIcon}
                      baseIndicators={item.baseIndicators}
                      numArrowData={item.numArrowData}
                      lineData={item.lineData}
                      lineDom={item.lineDom}
                      rankData={item.rankData}
                      index={index}
                      moduleName={moduleName}
                      isPolishing={isPolishing}
                      entityType={entityType}
                      rankLoading={rankLoading}
                      setActiveId={setActiveId}
                      conditionDate={conditionDate}
                      conditionMarket={conditionMarket}
                      gameId={gameId}
                      cardItem={item}
                      setActiveSegment={setActiveSegment}
                      isAdustTooltipPosition={isAdustTooltipPosition}
                      isOperateRegion={isOperateRegion}
                    />
                    {item?.metricUserGuide === 'digitalRevenue' && <UserGuideCompetitor />}
                  </Col>
                );
              })}
              <>
                {state ? (
                  <>
                    {cardDataMore?.map((item: any, index: number) => {
                      return item.titleIcon === 'viewers' ? null : (
                        <Col span={8}>
                          {/* <CardContext */}
                          <OverviewCard
                            key={`indicator${index}`}
                            index={index}
                            moduleName={moduleName}
                            titleContent={item.titleContent}
                            titleIcon={item.titleIcon}
                            baseIndicators={item.baseIndicators}
                            numArrowData={item.numArrowData}
                            lineData={item.lineData}
                            lineDom={item.lineDom}
                            rankData={item.rankData}
                            // reginonOnlyTips={true}
                            data_source={item.titleIcon}
                            entityType={entityType}
                            rankLoading={rankLoading}
                            setActiveId={setActiveId}
                            conditionDate={conditionDate}
                            conditionMarket={conditionMarket}
                            gameId={gameId}
                            cardItem={item}
                            setActiveSegment={setActiveSegment}
                            isAdustTooltipPosition={isAdustTooltipPosition}
                            isOperateRegion={isOperateRegion}
                          />
                        </Col>
                      );
                    })}
                  </>
                ) : (
                  ''
                )}
              </>
            </Row>
            {isPolishing && (
              <div className="performance-desc">
                <div className="performance-desc-type">
                  <span className="round-tip" style={{ background: '#5086F3' }} />
                  <span className="text-tip">Data from commercial data vendors</span>
                </div>
                <div className="performance-desc-type">
                  <span className="round-tip" style={{ background: '#F19E55' }} />
                  <SvgIcon type="a-select-icon" className="text-icon" />
                  <span className="text-tip">Data predicted by DataBrain</span>
                </div>
              </div>
            )}
            {cardDataMore?.length > 0 && (
              <Button
                type="link"
                className="performance-more"
                onClick={() => {
                  setState(!state);
                }}
              >
                {state ? 'Show Less' : 'Show All'}
              </Button>
            )}
          </>
        )}
      </Card.Body>
    </Card>
  );
}

export default connect((state: any) => {
  return {
    topchartsState: state[DBI_TOPCHARTS],
  };
})(PerformanceSummary);
